import { AFFINE_SLASH_MENU_WIDGET } from './consts';
import { AFFINE_MOBILE_SLASH_MENU, MobileSlashMenu } from './mobile-slash-menu';
import { InnerSlashMenu, SlashMenu } from './slash-menu-popover';
import { AffineSlashMenuWidget } from './widget';

export function effects() {
  customElements.define(AFFINE_SLASH_MENU_WIDGET, AffineSlashMenuWidget);
  customElements.define('affine-slash-menu', SlashMenu);
  customElements.define('inner-slash-menu', InnerSlashMenu);
  customElements.define(AFFINE_MOBILE_SLASH_MENU, MobileSlashMenu);
}

declare global {
  interface HTMLElementTagNameMap {
    [AFFINE_SLASH_MENU_WIDGET]: AffineSlashMenuWidget;
  }
}
